export const getFirstLineRect = (newMark: HTMLElement) => {
  const range = document.createRange()
  const treeWalker = document.createTreeWalker(newMark, NodeFilter.SHOW_TEXT)
  let node = treeWalker.nextNode()
  let firstLineWidth = 0

  if (node) {
    range.setStart(node, 0)
    range.setEnd(node, node.length)

    const rects = range.getClientRects()
    if (rects.length > 0) {
      const firstLineRect = rects[0]
      firstLineWidth = firstLineRect.width

      // 检查是否有更多文本节点在同一行
      while ((node = treeWalker.nextNode())) {
        range.setStart(node, 0)
        range.setEnd(node, node.length)
        const nodeRects = range.getClientRects()
        if (nodeRects.length > 0) {
          if (nodeRects[0].top === firstLineRect.top) {
            firstLineWidth += nodeRects[0].width
          } else {
            break // 下一行开始了
          }
        }
      }
    }
  }

  return firstLineWidth
}

export const removeFaviconAndTitle = () => {
  try {
    document.title = ''
    const favicon = document.querySelector('link[rel="icon"]')
    if (favicon) {
      favicon.href =
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
    }
  } catch {}
}
